import React from "react";
import { Text, TouchableHighlight, TouchableOpacity, View } from "react-native";
import { useTooltips } from "../../../context/WalkthroughContext";
import Tooltip from "react-native-walkthrough-tooltip";
import { AppColors } from "../../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import ImageComponent from "../../ImageComponent";
import { AppImages } from "../../../utility/AppImages";
import { CropImage } from "../../choose-avatar-components/CropImage";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import Avatar from "../../choose-avatar-components/Avatar";

const DescriptionWalkthrough = ({ scrollViewRef }) => {
  const {
    descriptionTooltipVisible,
    setDescriptionTooltipVisible,
    setDateTimeTooltipVisible,
    currentStep,
    totalSteps,
    handleNextStep,
  } = useTooltips();

  const deviceSize = useDeviceSize();

  const handleNextStepFromDateTimeTooltip = () => {
    // Scroll to a specific position in the ScrollView

    scrollViewRef.current?.scrollTo({
      y:
        deviceSize === DEVICE_SIZES.MD || deviceSize === DEVICE_SIZES.LG
          ? 500
          : 700,
      animated: true,
    });
    // Hide the organised tooltip and show the upcoming event tooltip
    setTimeout(() => {
      setDateTimeTooltipVisible(true);
    }, 500);
  };

  return (
    <View style={{ alignItems: "flex-start" }}>
      <Tooltip
        isVisible={descriptionTooltipVisible}
        contentStyle={{
          backgroundColor: AppColors.purple_453B50,
          width: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 736 : 350,
          borderColor: AppColors.white,
          shadowColor: "rgba(255, 255, 255, 0.65)",
          shadowOffset: { width: 0, height: 0 },
          shadowOpacity: 0.65,
          shadowRadius: 10.1,
          elevation: 5,
          borderWidth: 1,
          height: "auto",
        }}
        displayInsets={{
          top: 0,
          bottom: 0,
          left: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 300 : 10,
          right: 0,
        }}
        arrowStyle={{
          display: "none",
        }}
        content={
          <View>
            <View
              style={{
                flexDirection:
                  deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                    ? "row"
                    : "column",
                gap: 10,
              }}
            >
              {" "}
              <TouchableOpacity
                onPress={() => {
                  setDescriptionTooltipVisible(false);
                }}
                style={{ position: "absolute", right: 0, top: 0, zIndex: 1 }}
              >
                <ImageComponent
                  url={AppImages.icCloseWhiteSvg}
                  style={{
                    height: 16,
                    width: 16,
                    resizeMode: "contain",
                  }}
                />
              </TouchableOpacity>{" "}
              <View
                style={{
                  flexDirection: "row",
                  gap: 10,
                  alignItems: "center",
                }}
              >
                <Avatar
                  src="https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                  variant="walkthroughPlayer"
                />
                {deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ? (
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      { color: AppColors.white }, // Set text color for better readability
                    ]}
                  >
                    Set the Rules & Game Mode ⚙️
                  </Text>
                ) : null}
              </View>
              <View
                style={{
                  flex: 1,
                  marginTop:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 0
                      : 12,
                }}
              >
                <View style={{ gap: 10 }}>
                  {deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ? null : (
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_16,
                        { color: AppColors.white },
                      ]}
                    >
                      Set the Rules & Game Mode ⚙️
                    </Text>
                  )}
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { lineHeight: 21 },
                    ]}
                  >
                    Define the rules and select the game mode. For the best
                    viewer experience, we recommend choosing a game mode that
                    lasts a minimum of 15 minutes to keep your audience engaged
                    and entertained.
                  </Text>
                </View>
              </View>
            </View>{" "}
            <View
              style={{
                gap: 10,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
                marginTop: 10,
              }}
            >
              <Text
                style={{
                  ...AppFontStyle.REGULAR_ANYBODY_12,
                  color: AppColors.green_00FFE8,
                }}
              >
                {currentStep + 1} / {totalSteps}
              </Text>
              <TouchableOpacity
                onPress={() => {
                  setDescriptionTooltipVisible(false);
                  handleNextStepFromDateTimeTooltip();
                  handleNextStep();
                }}
                style={{
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  width: 70,
                  height: 20,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 10,
                }}
              >
                <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
              </TouchableOpacity>
            </View>
          </View>
        }
        placement={"top"}
      >
        <TouchableHighlight>
          <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>
            Description & Rules
          </Text>
        </TouchableHighlight>
      </Tooltip>
    </View>
  );
};

export default DescriptionWalkthrough;
